import { keyframes } from '@emotion/react';
import css from '@styled-system/css';

import { linearGradient } from '../../internal/styles/linearGradient';

const waves = keyframes`
  0% { transform: translate3d(-100%, 0, 0); }
  100% { transform: translate3d(100%, 0, 0); }
`;

const wavesEffect = () =>
  css({
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundImage: linearGradient('to right', [
        'rgba(255, 255, 255, 0) 0%',
        'rgba(255, 255, 255, .4) 20%',
        'rgba(255, 255, 255, .6) 50%',
        'rgba(255, 255, 255, .4) 80%',
        'rgba(255, 255, 255, 0) 100%',
      ]),
      animation: `${waves} 1s ease-in-out infinite`,
    },
  });

export default wavesEffect;
